import {
    PLATFORMS_FETCH,
    PLATFORMS_IS_FETCING,
    PLATFORM_FILTER,
    PLATFORM_EDIT,
} from 'constants/platforms'

export default function platformsReducer(state = {
    list: [],
    pageable: {
        sort: {
            'platformId': false,
            'name': 'asc',
            'type': false,
            'urlAddress': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case PLATFORMS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case PLATFORM_EDIT:
            return {
                ...state,
            }
        case PLATFORMS_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case PLATFORM_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/platforms.js